import { Button as MuiButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  root: {
    "&.MuiButton-root": {
      margin: "1rem",
      padding: "1.8rem 8rem",
      fontFamily: "Rajdhani",
      fontSize: "1.5rem",
      fontWeight: 500,
      lineHeight: "16px",
      letterSpacing: "1px",
      color: "#FFFFFF",
      borderColor: "#282828",
      transition: "color 0.3s",
    },
  },
});

function Button(props) {
  const classes = useStyles();
  const { text, variant, color, size, onClick, ...others } = props;
  return (
    <MuiButton
      variant={variant || "outlined"}
      size={size || "large"}
      color={color || "secondary"}
      onClick={onClick}
      {...others}
      className={classes.root}
    >
      {text}
    </MuiButton>
  );
}

export default Button;
